import React, { useContext, useState, useMemo } from 'react';
import { LanguageContext } from "../config/multilingualContext";
import MultiLingualContent from "../config/multilingualContent";
import { getLabel } from "../functions/lang";
import ExportDropdown from './ExportDropdown';
import FormattedNumber from './FormattedNumber';
import StatTableBody from './StatTableBody';
import StatTableHead from './StatTableHead';

const Combfgazmstat = (props) => {
    const { language } = useContext(LanguageContext);
    const { configsColumn, tableStatData, configsLine } = props;

    const colors = ['#f2ce61', '#fff2cc', '#94b8da', '#c6e0b4'];
    let colorIndex = -1;

    // Track expanded rows by level-1 fk_data_id
    const [expanded, setExpanded] = useState({});

    // Build parent -> children map for fast lookup
    const childrenMap = useMemo(() => {
        const map = {};
        if (!configsLine) return map;

        const stack = [];
        configsLine.forEach(item => {
            while (stack.length > 0 && stack[stack.length - 1].level >= item.level) {
                stack.pop();
            }
            const parent = stack.length > 0 ? stack[stack.length - 1] : null;
            if (parent) {
                map[parent.fk_data_id] = map[parent.fk_data_id] || [];
                map[parent.fk_data_id].push(item.fk_data_id);
            }
            stack.push(item);
        });
        return map;
    }, [configsLine]);

    // Determine which rows are visible based on expanded level-1 rows
    const visibleSet = useMemo(() => {
        const vis = new Set();
        if (!configsLine) return vis;

        let currentLevel1 = null;
        configsLine.forEach(item => {
            if (item.level === 1) {
                currentLevel1 = item.fk_data_id;
                vis.add(item.fk_data_id);
            } else {
                if (currentLevel1 == null) {
                    vis.add(item.fk_data_id);
                } else {
                    if (expanded[currentLevel1]) vis.add(item.fk_data_id);
                }
            }
        });
        return vis;
    }, [configsLine, expanded]);

    return (
        <div style={{ width: '100%' }}>
            {/* Export button */}
            {tableStatData && Object.keys(tableStatData).length > 0 &&
                <ExportDropdown
                    tableData={tableStatData}
                    columns={configsColumn}
                    filenamePrefix={`combfgazmstat`}
                    configsLine={configsLine}
                    language={language}
                    showUnitRow={true}
                    showTotal={false}
                />
            }

            {/* Scrollable table */}
            <div style={{ overflowY: 'scroll', height: '100vh' }}>
                {tableStatData && Object.keys(tableStatData).length > 0 ? (
                    <table
                        className="table table-bordered stripe display mt-2"
                        style={{ width: '100%', overflow: 'scroll' }}
                    >
                        <StatTableHead configsColumn={configsColumn} language={language} />
                        <StatTableBody
                            configsLine={configsLine}
                            configsColumn={configsColumn}
                            tableStatData={tableStatData}
                            language={language}
                            colors={colors}          // Pass colors to body
                        />
                    </table>
                ) : (
                    <p><MultiLingualContent contentID="nodata" /></p>
                )}
            </div>
        </div>
    );
};

export default Combfgazmstat;